<!-- 角色管理 -->
<template>
<div style="height:100%;">
    <!-- 第一行 搜索栏 -->
    <!-- 第一行 搜索栏 -->
    <div class="selectionBar">
        <div class="flex flex-ai-c flex-jc-sb flex-wrap">
            <label>场景：</label>
            <el-button type="primary" size="small" @click="edit()">
                <i class="el-icon-circle-plus-outline"></i>
                添加角色
            </el-button>
        </div>
    </div>

    <div class="table" style="height:calc( 100% - 140px )">
        <el-table ref="multipleTable" :data="list" :header-cell-style="{background:'#f5f7fa',color:'#909399'}" height="100%" style="width: 100%">
            <el-table-column prop="name" label="角色名称" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150" show-overflow-tooltip align="center">
                <template slot-scope="scope" v-if="scope.row.id != 1">
                    <el-button-group>
                        <el-button :disabled="scope.row.system_is==1" type="primary" icon="el-icon-edit" size="small" @click="edit(scope.row)"></el-button>
                        <el-button :disabled="scope.row.system_is==1" type="primary" icon="el-icon-delete" size="small" @click="del(scope.row)"></el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div class="paging">
                    <el-pagination @current-change="currChange" @size-change="rowChange" :current-page="curr" :page-size="row" :total="count" background layout="total, sizes, prev, pager, next, jumper" ></el-pagination>
                </div> -->
    </div>

    <!-- <roleEdit ref="roleEdit"></roleEdit> -->

    <!-- 添加和编辑框 -->
    <el-dialog custom-class="nDialog" :visible="dialogOpen" :title="dialogTitle" :close-on-click-modal="false" width="600px" @close=" dialogOpen=false " :append-to-body="true" :destroy-on-close="true">
        <el-form ref="edit" :model="detail" :rules="rules" @submit.native.prevent label-width="80px">
            <el-form-item label="角色名称" prop="name">
                <el-input v-model="detail.name" size="small"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogOpen=false">取 消</el-button>
            <el-button size="small" type="primary" @click="save()">确 定</el-button>
        </div>
    </el-dialog>

</div>
</template>
<script>
export default {
    data: function() {
        return {
            list: [],
            detail: {},
            dialogTitle: '',
            dialogOpen: false,
            rules: {
                name: [{
                    required: true,
                    message: '请输入角色名称',
                    trigger: 'blur'
                }, ],
            }
        }
    },
    mounted: function() {
        this.init()
    },
    methods: {
        init: function() {
            this.getList();
        },
        getList: function() {
            this.http.post('/admin/roles/getList').then(res => {
                this.list = res
            })
        },

        //保存
        save: function() {
            this.$refs['edit'].validate((valid) => {
                if(valid) {
                    // var api
                    // if( typeof this.detail.id == 'undefined' ){
                    // 	var api = "/Role/create";
                    // }else{
                    var api = "/admin/roles/edit";
                    // }
                    this.http.post(api, this.detail).then(() => {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                        this.dialogOpen = false
                        this.getList()
                    })
                }
            })
        },

        //编辑
        edit: function(detail = {}) {
            if(typeof detail.id == 'undefined') {
                this.dialogTitle = '添加角色'
            } else {
                this.dialogTitle = '编辑角色'
            }
            this.dialogOpen = true
            this.detail = JSON.parse(JSON.stringify(detail))
        },

        //删除
        del: function(detail) {
            if(confirm('确定要删除吗？')) {
                var api = '/admin/roles/delete'
                this.http.post(api, {
                    id: detail.id
                }).then(() => {
                    this.$message({
                        message: '已删除',
                        type: 'success'
                    })
                    this.dialogOpen = false
                    this.getList()
                })
            }
        }

    }
}
</script>
